wbApp.directive('wbActivityWeekSelector', [
    function () {

        function createScheduleModel(weeks, selection, restrictToSchedules) {

            function isSelected(selection, week) {
                for (var i = 0; i < selection.length; i++) {
                    var s = selection[i];
                    if (s.weekNo === week.weekNo &&
                        moment(s.startDate).isSame(moment(week.startDate))) {
                        return true;
                    }
                }
                return false;
            }

            function Schedule(weeks, selection, restrictToSchedules) {
                this.rows = [];
                this.restrictToSchedules = restrictToSchedules;

                var newRow = [];
                this.rows.push(newRow);

                for (var idx = 0; idx < weeks.length; idx++) {
                    if (idx % 6 === 0 && idx > 0) {
                        newRow = [];
                        this.rows.push(newRow);
                    }
                    newRow.push({
                        selected: isSelected(selection, weeks[idx]) &&
                            ((weeks[idx].schedules && weeks[idx].schedules.length > 0) || !this.restrictToSchedules),
                        week: weeks[idx]
                    });
                }
            }

            Object.defineProperty(Schedule.prototype, 'allSelected', {
                enumerable: true, configurable: true,
                get: function () {
                    var selected = true;
                    for (var r = 0; r < this.rows.length; r++) {
                        var row = this.rows[r];
                        for (var c = 0; c < row.length; c++) {
                            var column = row[c];
                            if ((column.week.schedules && column.week.schedules.length > 0) || !this.restrictToSchedules) {
                                selected &= column.selected;
                            }
                        }
                    }
                    return selected !== 0;
                },
                set: function (val) {
                    for (var r = 0; r < this.rows.length; r++) {
                        var row = this.rows[r];
                        for (var c = 0; c < row.length; c++) {
                            var column = row[c];
                            if ((column.week.schedules && column.week.schedules.length > 0) || !this.restrictToSchedules) {
                                column.selected = val;
                            }
                        }
                    }
                }
            });

            return new Schedule(weeks, selection, restrictToSchedules);
        }

        return {
            restrict: 'A',
            priority: 1,
            replace: true,
            scope: {
                ngModel: '=',
                selection: '=',
                restrictToSchedules: '=',
                ngChange: '&'
            },
            templateUrl: 'activities/directives/activity-week-selector.html',
            link: function (scope, elem, attrs) {

                scope.schedule = [];

                scope.$watch('ngModel', function (newValue, oldValue) {
                    if (scope.selection) {
                        scope.schedule = createScheduleModel(newValue, scope.selection, scope.restrictToSchedules);
                    }
                });

                scope.$watch('schedule', function (model) {
                    scope.selection.length = 0;
                    for (var r = 0; r < model.rows.length; r++) {
                        var row = model.rows[r];
                        for (var c = 0; c < row.length; c++) {
                            var column = row[c];
                            if (column.selected) {
                                scope.selection.push(column.week);
                            }
                        }
                    }
                    if (scope.ngChange()) {
                        scope.ngChange()(scope.selection);
                    }
                }, true);
            }
        }
    }]);